import GetApiKeysRequestModelBase from '../_generated/modelBases/get-api-keys-request-model-base';

export default class GetApiKeysRequestModel extends GetApiKeysRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
